import { Grid2 } from "@mui/material"
import React from "react"

export function AnalysisTableHeader({ columns }) {
    return (
        <Grid2 container spacing={1}>
            {columns.map((col) => (
                <Grid2 key={col.field} size={col.size} padding={1}>
                    {col.field}
                </Grid2>
            ))}
        </Grid2>
    )
}
